import { Button, Menu, MenuItem, Chip } from '@mui/material';
import { IconMenu2 } from '@tabler/icons-react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DrawerMenu from '../../pages/Home/components/DrawerMenu';
import { LogoutOptions, useAuth0 } from '../../auth/AuthProvider';
import useGetUser from '../../hooks/useGetUser';
import useGetPartner from '../../hooks/useGetPartner';

const Header = () => {
  const navigate = useNavigate();
  const [isShowDrawer, setIsShowDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { isAuthenticated, logout, user } = useAuth0();
  const open = Boolean(anchorEl);
  const { user: userData } = useGetUser(
    user?.sub ?? '',
    isAuthenticated && !!user?.sub,
  );
  const { partner, isLoading: partnerLoading } = useGetPartner();

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout({ returnTo: window.location.origin } as LogoutOptions);
    handleClose();
  };

  return (
    <div className="flex items-center lg:items-start justify-between my-4 mx-6 gap-4 lg:mx-36 lg:max-h-40">
      <button
        className="block lg:hidden"
        onClick={() => setIsShowDrawer(true)}
        aria-label="menu"
      >
        <IconMenu2 />
      </button>
      <Link to="/" className="hidden lg:block shrink-0">
        <img
          className="h-8 w-[120px] object-contain cursor-pointer"
          src="https://imagedelivery.net/KQLaZdBjDzxarhwBRuqRFg/33a0d3dd-4713-44fc-2792-1237db489400/public"
          alt="Santtai"
          width={120}
          height={32}
        />
      </Link>
      <div className="hidden lg:block">
        <>
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleMenu}
          >
            <span>
              Welcome back, {userData?.fullName?.split(' ')[0] || 'User'}!
            </span>
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
              list: {
                'aria-labelledby': 'basic-button',
              },
            }}
          >
            <MenuItem
              onClick={() => {
                navigate('/profile');
                handleClose();
              }}
            >
              Edit Profile
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigate('/app/tripmanagement');
                handleClose();
              }}
            >
              My trips
            </MenuItem>
            {!partnerLoading && partner && (
              <MenuItem
                onClick={() => {
                  navigate('/partner');
                  handleClose();
                }}
              >
                Partner Portal
                <Chip
                  label="Partner"
                  size="small"
                  color="primary"
                  sx={{ ml: 1, height: 20 }}
                />
              </MenuItem>
            )}
            <MenuItem onClick={handleLogout}>Log Out</MenuItem>
          </Menu>
        </>
      </div>
      <DrawerMenu
        isShowDrawer={isShowDrawer}
        setIsShowDrawer={setIsShowDrawer}
      />
    </div>
  );
};

export default Header;
